module.exports = __webpack_public_path__ + "static/background-small-42f6eebf64f5085a0d85d52920e31ca2.jpg";